__turbopack_context__.v({
  "availabilityText": "ZBXIJW_availabilityText",
});
